export enum MenuEnum {
  HOME = 'home',
  SIMULATION = 'simulation',
  RECORDS = 'records',
  LEADS = 'leads',
  PARAMETERS = 'parameters',
  LOGOUT = 'logout',
  ADMINISTRATION = 'administration'
}
